var _ellipse, _path, _path2, _path3, _rect, _line, _line2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmailLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 42,
    viewBox: "0 0 63 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.5,
    cy: 21.5,
    rx: 15.5,
    ry: 16.5,
    fill: "#1989FA",
    fillOpacity: 0.970833
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 16L12.5 10C14.4545 7.91799 15.8299 7.12605 18.5 6L19.5 6.5L22 11L23 12.5V16L25.5 18.5L26.5 25L21.5 22.5L19.5 26L14 21L11 16Z",
    fill: "#07C180"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 28.5L10.5 30C13.6188 35.5297 18.2034 38.1877 23.5 38L24 35V32.5L20.5 31.5V28.5L17 29.5L13.5 28.5Z",
    fill: "#07C180"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31 27.5C31 27.5 27.9565 34.0604 31.5 35C35.0435 35.9396 44.3523 21.5775 35 11L33 12L31.5 13L33 14L34 17.5L33.5 20H31V23L29.5 25L31 27.5Z",
    fill: "#07C180"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 27.5,
    y: 23.5,
    width: 30,
    height: 16,
    fill: "#F7F8FA",
    stroke: "#E2E2E2"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 57.2572,
    y1: 23.4287,
    x2: 42.2572,
    y2: 32.4287,
    stroke: "#E2E2E2"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 28.2572,
    y1: 23.5713,
    x2: 43.2572,
    y2: 32.5713,
    stroke: "#E2E2E2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailLogo);
export default __webpack_public_path__ + "static/media/email-logo.5dd9d9c12401ef0451ed7ab22a2ee1ab.svg";
export { ForwardRef as ReactComponent };